<template>
    <div>
        <site-header></site-header>
        <log-in-form></log-in-form>
        <site-footer></site-footer>
    </div>
</template>
<script>
import LogInForm from "./components/organisms/OrganismLoginForm.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";

export default {
    components: {
        SiteHeader,
        LogInForm,
        SiteFooter
    },
    metaData() {
        return {
            title: "Logga in",
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content:
                        "Som kund kan du redigera dina förfrågningar, kontaktuppgifter och sätta omdöme när du loggat in. Är du hantverkare kan du besvara förfrågningar, ändra sökprofil, redigera din profilsida m.m."
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `${process.env.SITE_BASE_URL}${this.$route.path}`
                }
            ]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Login.vue